export default "__VITE_ASSET__D47iwJkL__"